import ContractBasisDetails from 'app/Apps/Pricing/ContractBasis/ContractBasisDetails/ContractBasisDetails'
import {
    SkyNetTableField,
} from 'app/shared-components/SkyNetTable'
import {
    ContractBasisTable,
} from 'app/Apps/Pricing/Pricing.types'
import {
    CommonRoutes,
    FilterType,
} from 'app/enums/common.enums'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    RequestConfig,
} from 'app/types/request.types'
import ContractBasisRequests from 'app/requests/ContractBasis/ContractBasis.requests'
import {
    ContractBasisTabs,
    PricingDomains,
} from 'app/enums/domain.enums'
import {
    SkyNetDataGridFilterType,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid/SkyBaseDataGrid.types'

import {
    SkyNetObjectConfigParams,
} from '../SkyNetObjectRoutes/SkyNetObjectRoutes.types'
import ContractBasisDemoAdditionalFees from './ContractBasisDemoAdditionalFees'

const NDA_LABEL = 'NDA'

type ContractBasisTableFields = ContractBasisTable & {
    additionalFeesValidTo?: string
}

const columns: SkyNetTableField<keyof ContractBasisTableFields>[] = [
    {
        name: 'contractBasisNumber',
        labelKey: 'ContractBasis.contractBasisId',
        reduced: true,
    },
    {
        name: 'customerQuotationLocationName',
        filterField: 'customerQuotationLocationName',
        filterType: FilterType.Array,
        reduced: true,
        labelKey: 'ContractBasisUpdateDto.customerQuotation',
    },
    {
        name: 'accountCompanyCompanyName',
        filterField: 'accountCompanyCompanyName',
        filterType: FilterType.Array,
        mapCellProps: ({
            hasNDA,
            accountCompanyCompanyName,
        }) => {
            return {
                children: `${hasNDA ? NDA_LABEL : accountCompanyCompanyName}`,
            }
        },
        reduced: true,
        labelKey: 'Prebooking.pricingAccount', // if labelKey don't have . - than will take labelEntityName.labelKey
        customFilterItemLabelConverter: (value) => {
            return value || NDA_LABEL
        },
    },
    {
        name: 'accountIsStrategicAccount',
        labelKey: 'Accounts.strategicAccount',
        componentName: 'ChipCheckMark',
    },
    {
        name: 'currency',
        filterField: 'currency',
        filterType: FilterType.Array,
        labelKey: 'LaneOpsInformationDto.currency',
    },
    {
        name: 'keyAccountManager',
        filterField: 'keyAccountManager',
        filterType: FilterType.Array,
        labelKey: 'AccountQuotes.keyAccountManager',
    },
    {
        name: 'businessDevelopers',
        filterField: 'businessDevelopers',
        filterType: FilterType.Array,
        componentName: 'List',
        labelKey: 'ContractBasisFlat.businessDevelopers',
    },
    {
        name: 'additionalFeesValidTo',
        filterField: 'additionalFeesValidTo',
        filterType: SkyNetDataGridFilterType.TimeLessDateRange,
        componentName: 'LaneDateEnriched',
        labelKey: 'LaneGroupView.additionalFeesValidTo',
    },
]

const request: RequestConfig = {
    url: 'contractbasis/filter-request/all',
    method: 'POST',
} // TODO-DK: for test purposes only, remove it afterwards, take from requests.ts

export const formViews = [
    {
        label: 'Contract Basis',
        url: PricingDomains.ContractBasis,
        Component: ContractBasisDetails,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ContractBasisRequests.get,
            requestKey: RequestKeys.getContractBasis,
        },
    },
    {
        label: 'Additional Fees',
        url: ContractBasisTabs.AdditionalFees,
        Component: ContractBasisDemoAdditionalFees,
        skyNetQueryLoaderConfig: {
            requestConfigFunction: ContractBasisRequests.get,
            requestKey: RequestKeys.getContractBasis,
        },
    },
]

const ContractBasisDemoConfig: SkyNetObjectConfigParams<keyof ContractBasisTable> = {
    persistentKey: 'demo-contractBasis-table',
    formViews,
    columns,
    uniqField: 'id',
    config: [{
        url: CommonRoutes.All,
        name: 'All',
        requestKey: RequestKeys.getContractBasisList,
        request,
    }],
    actionComponents: {
        Create: {
            component: ContractBasisDetails,
            accessOnly: ['contract_basis_create'],
        },
    },
}

export default ContractBasisDemoConfig
